import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVivo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 18,
	viewBox: "0 0 50 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Vivo_Dark 2",
		clipPath: "url(#clip0_1828_36227)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Layer_1-2",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M10.6396 17.4661H7.39696L0.714355 1.22205H3.74396L8.91787 14.4418H9.11694L14.2926 1.22205H17.31L10.6396 17.4661Z",
					fill: "#1D7089"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M21.6405 17.4661H18.9479V5.27353H21.6405V17.4661ZM21.6806 1.9508C21.6806 2.71251 21.059 3.32847 20.2942 3.32847C19.5294 3.32847 18.9077 2.71077 18.9077 1.9508C18.9077 1.19082 19.5294 0.57312 20.2942 0.57312C21.059 0.57312 21.6806 1.19082 21.6806 1.9508Z",
					fill: "#1D7089"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M31.3438 17.4662H28.4259L23.376 5.27356H26.2816L29.8228 14.6778H29.973L33.4898 5.27356H36.3832L31.3455 17.4662H31.3438Z",
					fill: "#1D7089"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M40.0744 16.9334C38.1169 15.8923 36.9941 13.9473 36.9941 11.4314C36.9941 10.1682 37.2683 9.0647 37.8044 8.11039C38.8765 6.22606 40.8846 5.12427 43.4899 5.12427C44.7995 5.12427 45.9468 5.3828 46.9194 5.90333C48.8646 6.95654 49.9996 8.9016 49.9996 11.4296C49.9996 12.6807 49.7255 13.7825 49.1894 14.7246C48.105 16.6211 46.1214 17.7107 43.4916 17.7107C42.182 17.7107 41.047 17.4505 40.0744 16.9299V16.9334ZM45.6115 15.1254C46.7221 14.3446 47.2581 12.9808 47.2581 11.4331C47.2581 10.6523 47.1202 9.93398 46.8583 9.27638C46.31 7.97505 45.1994 7.11964 43.4916 7.11964C42.643 7.11964 41.9445 7.31744 41.3962 7.70264C40.2857 8.49558 39.7374 9.85937 39.7374 11.4331C39.7374 12.2139 39.8753 12.9201 40.1495 13.5638C40.6978 14.8652 41.7961 15.7206 43.4916 15.7206C44.3525 15.7206 45.0492 15.5228 45.6115 15.1254Z",
					fill: "#1D7089"
				})
			]
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1828_36227",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 49.2857,
			height: 17.1429,
			fill: "white",
			transform: "translate(0.714355 0.571411)"
		})
	}) })]
});
export default SvgVivo;
